<template>
  <span>
    <loading-indicator v-if="loading" />
    <div v-if="!loading" class="link-preview-card" @click.prevent="openLink">
      <img class="link-preview-card__image" :src="image" alt="Link Thumbnail">
      <div class="link-preview-card__title">{{ title }}</div>
      <div class="link-preview-card__description">{{ description }}</div>
      <div class="link-preview-card__domain">{{ domain }}</div>
    </div>
  </span>
</template>

<script>
// @flow

import { mapState } from 'vuex'

import { ChatchampApi } from '../../../common/api/chatchampApi'
import { LoadingIndicator } from '../../../common/components'

export default {
  components: { LoadingIndicator },
  props: {
    message: {
      type: Object, // ChatBubbleMessage<TextContent>
      default: () => {
      }
    }
  },
  data () {
    return {
      loading: true,
      title: '',
      description: '',
      image: '',
      domain: '',
      url: ''
    }
  },
  computed: {
    ...mapState(['customerId'])
  },
  async mounted () {
    await this.fetchLinkPreviewData()
  },
  methods: {
    openLink () {
      window.open(this.message.getUrlFromText(), '_blank')
    },
    async fetchLinkPreviewData () {
      const data = await new ChatchampApi(this.customerId).getLinkPreview(this.message.getUrlFromText())
      this.title = data.title
      this.description = data.description
      this.image = data.image
      this.domain = data.domain
      this.url = data.url
      this.loading = false
    }
  }
}
</script>

<style src="./link-preview-card.scss" />
